<template>
  <CrudList title="Terminos y Condiciones" storeName="Terms" labelAddNew="Agregar" slot-scope="{ item }" sortable
    canSearch next-link="/admin/dashboard" :breadcrumbs="[
      {
        text: 'Configuración y politicas',
        disabled: false,
        href: '/admin/terms'
      },
      {
        text: 'Terminos y Condiciones',
        disabled: false,
        href: '#'
      }
    ]">
    <template v-slot:description="{ item }">
      <v-container id="scroll-target" style="max-height: 210px" class="overflow-y-auto">
        <v-row v-scroll:#scroll-target="onScroll">
          <p> {{ item.description }}</p>
        </v-row>
      </v-container>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
